import React from "react";

const n = (valor) => Number(valor ?? 0).toLocaleString("es-CO");
const CHIP = { background: "#EEF4F9", color: "#22629B", borderRadius: 999, padding: "2px 10px", fontSize: 12, display: "inline-flex", gap: 6, alignItems: "center", whiteSpace: "nowrap" };
const OK = { background: "#DDF7E2", color: "#0D5120" };

/**
 * Formatos de un conjunto de seriales (Diego 2026-10-16): con uno se muestra el serial; con miles se dice cuántos hay,
 * que no hay repetidos, cuántos confirmó el reconocimiento físico y qué formatos tienen (letras A, dígitos 9) con un
 * ejemplo de cada uno. Pieza única para el RC 198 Seriales de la importación y el informe de la inspección previa.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-10-16
 */
const Formaser = ({ resumen, etiquetaConfirmado = "confirmado por RECO", compacto = false }) => {
  const formas = resumen?.FORMAS ?? [];
  if (formas.length === 0) return null;
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: compacto ? 4 : 6 }}>
      {!compacto && <span style={{ fontSize: 12, color: "#5B6770", alignSelf: "center" }}>{formas.length === 1 ? "Formato:" : `${formas.length} formatos:`}</span>}
      {formas.map((f) => (
        <span key={f.FORMA} style={{ ...CHIP, ...(f.CONFIRMADOS > 0 && f.CONFIRMADOS === f.CANTIDAD ? OK : {}) }} title={`Forma ${f.FORMA} · ${f.LARGO} caracteres`}>
          <b>{f.EJEMPLO}</b>
          <span>· {n(f.CANTIDAD)} {f.CANTIDAD === 1 ? "serial" : "seriales"}</span>
          {f.CONFIRMADOS > 0 && <span>· {f.CONFIRMADOS === f.CANTIDAD ? (f.CANTIDAD === 1 ? etiquetaConfirmado : `todos ${etiquetaConfirmado}s`) : `${n(f.CONFIRMADOS)} ${etiquetaConfirmado}s`}</span>}
        </span>
      ))}
    </div>
  );
};

export default Formaser;
